import { Component, computed, HostListener, input, output, ChangeDetectionStrategy } from '@angular/core';

import { MdwIcon } from '@spaces-ui/meadow/icons';
import { Chevron_Down } from '@spaces-ui/meadow/icons/svgs';
import { EventUtils } from '@spaces-ui/utils';

import { TableSort } from '../../models';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[mdwTableSortCell]',
  templateUrl: './sort-header.html',
  styleUrls: ['./sort-header.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MdwIcon],
})
export class MdwTableSortHeader<T> {
  public tableSort = input.required<TableSort<T>>();
  public sortProperty = input.required<keyof T>();

  public sort = output<TableSort<T>>();

  public icons = { Chevron_Down };

  public isActive = computed(() => {
    const tableSort = this.tableSort();
    const sortProperty = this.sortProperty();

    return tableSort.sortProperty === sortProperty;
  });

  public sortIconRotation = computed(() => {
    const tableSort = this.tableSort();
    const sortProperty = this.sortProperty();

    if (tableSort.sortProperty === sortProperty) {
      return tableSort.sortDirection === 'desc' ? 0 : 180;
    }

    return 0;
  });

  @HostListener('click', ['$event'])
  public onClick(event: MouseEvent): void {
    EventUtils.preventBubble(event);

    const tableSort = this.tableSort();
    const sortProperty = this.sortProperty();

    if (tableSort.sortProperty === sortProperty) {
      this.sort.emit({
        sortProperty,
        sortDirection: tableSort.sortDirection === 'asc' ? 'desc' : 'asc',
      });
    } else {
      this.sort.emit({
        sortProperty,
        sortDirection: 'asc',
      });
    }
  }
}
